import * as React from 'react'
import styled from 'styled-components'

import { defaultTheme as theme } from '../../../theme'
// import { Header } from '../../banner'
import { Header } from '../../header'
import { Banner } from '../../banner'

interface NavbarProps {
  invert?: boolean
  index?: boolean
  loc?: any
}

export const Navbar: React.FC<NavbarProps> = (props: NavbarProps) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false)

  function closeOnResize() {
    isMobileMenuOpen && setIsMobileMenuOpen(false)
  }

  React.useEffect(() => {
    window.addEventListener('resize', closeOnResize)
    return () => window.removeEventListener('resize', closeOnResize)
  }, [isMobileMenuOpen])

  return (
    <React.Fragment>
      {/*<BannerWrapper light={true}>
        <Banner
          text={
            <a href="https://console.prisma.io?utm_source=website&utm_medium=banner&utm_campaign=accelerate-ga" className="banner-url">
              Prisma Accelerate now in GA {'->'} Subscribe by November 12th to get <b>50% off</b> the base price
            </a>
          }
        />
        </BannerWrapper>*/}
      <NavContainer id="navbar" className={isMobileMenuOpen ? 'mobileMenuOpen' : undefined}>
      <Header lightTheme={props.index ? false : true} notFixed={true} clearBg={props.index ? true : false} loc={props.loc}/>
      </NavContainer>
    </React.Fragment>
  )
}


const BannerWrapper = styled.div<{ light: boolean }>`
  a {
    color: ${(props) => (props.light ? theme.colors.gray['800'] : theme.colors.gray['300'])};
  }
  b {
    ${(props) => !props.light && `color: ${theme.colors.teal['400']};`}
  }
  width: 100%;
  transition: margin-top 50ms ease-in;
  top: 0;
  z-index: -1;
` 
// STYLED COMPONENTES

const NavContainer = styled.nav`
  display: flex;
  color: ${theme.colors.white};
  .logo-container {
    a {
      display: inline-flex;
    }
  }
  .group-right {
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
    .desktop-menu-container {
      display: none;
    }
    .mobile-menu-btn {
      display: flex;
      align-items: center;
    }
  }
  .mobile-menu-container {
    width: 100%;
    height: 100%;
    padding-top: 1rem;
  }
  &.mobileMenuOpen {
    position: fixed;
    z-index: 999;
    inset: 0;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    padding-left: 1rem;
    padding-right: 1rem;

    background-color: ${theme.colors.white};
    flex-wrap: wrap;
  }
  @media (min-width: 768px) {
    .logo-container {
    }
    .group-right {
      .desktop-menu-container {
        display: flex;
        align-items: center;
      }
      .mobile-menu-btn {
        display: none;
      }
    }
  }
`

const MobileMenuBtn = styled.button`
  background-color: transparent;
  display: flex;
  padding: 0;
  margin: 0;
  border: 0;
`
